import './../../assets/css/views/notFound/NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found">
      <img src={require('../../assets/img/POS_LOGO.png')} style={{ width: '144px', height: '144px', borderRadius: '30px' }} />
      <br />
      <h1>404</h1>
      <p>Página no encontrada</p>
      <a href={process.env.PUBLIC_URL}>Volver a la página principal</a>
    </div>
  );
};

export default NotFound;
